import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo, useRef } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";

import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { Box, Button } from "@mui/material";
import Select from "react-select";

const PDMCList = () => {
    const navigate = useNavigate();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState([]);
    const [farmerData, setfarmerData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [hasNextPage, setHasNextPage] = useState(true);
    const [LoaderFarmer, setLoaderFarmer] = useState(false);
    const [isFetchingState, setIsFetchingState] = useState(true);
    // Ref to track fetched village keys to prevent infinite loops
    const fetchedVillageKeys = useRef(new Set());
    const [selectedDataSetDistrict, setselectedDataSetDistrict] = useState('');
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState([]);
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState([]);
    const [optionActivity, setOptionActivity] = useState([]);
    const [activityValue, setactivityValue] = useState([]);
    const [selectedDataSetSubDistrict, setselectedDataSetSubDistrict] = useState('');
    const [selectedDataSetVillage, setselectedDataSetVillage] = useState('');
    const [surveyValue, setSurveyValue] = useState("");
    const [surveyorNameValue, setSurveyorNameValue] = useState("");
    const [mobilenoValue, setMobilenoValue] = useState("");
    const [landareaValue, setlandareaValue] = useState("");
    const [totalareaValue, settotalareaValue] = useState("");
    const [surveynoValue, setSurveynoValue] = useState("");
    const [editCode, setEditCode] = useState({});
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [cropSeason, setCropSeason] = useState([]);
    const [cropSeasonValue, setCropSeasonValue] = useState(''); 
    const [cropGroup, setCropGroup] = useState([]);
    const [cropGroupValue, setCropGroupValue] = useState('');
    const [cropName, setCropName] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [cropNameValue, setCropNameValue] = useState('');
    // Add state variables to track which dropdowns should be disabled
    const [isStateDisabled, setIsStateDisabled] = useState(false);
    const [isDistrictDisabled, setIsDistrictDisabled] = useState(false);
    const [isSubDistrictDisabled, setIsSubDistrictDisabled] = useState(false);

    const getStoredDistrictRef = () => {
        const districtCode = sessionStorage.getItem("districtCodeModel");
        const districtName = sessionStorage.getItem("districtNameModel");
        if (districtCode && districtCode !== "null" && districtCode !== "0") {
            return districtCode;
            
        }
        if (districtName && districtName !== "null" && districtName !== "0") {
            return districtName;
        }
        return "";
    };

    const findMatchingOption = (options, ref) => {
        if (!ref || ref === "null" || ref === "0") return null;
        const refStr = String(ref).trim();
        return options.find((option) =>
            String(option.value) === refStr ||
            option.value == ref ||
            String(option.label).trim().toLowerCase() === refStr.toLowerCase()
        ) || null;
    };

    const findDistrictSelectValue = (options, selectedDistrict) => {
        if (!selectedDistrict || selectedDistrict === "null" || selectedDistrict === "0") return null;
        return findMatchingOption(options, selectedDistrict);
    };
    const isOptionSelected = (selectedValues, option) => {
        if (!Array.isArray(selectedValues) || selectedValues.length === 0) return false;
        return selectedValues.some((selected) =>
            String(selected) === String(option.value) ||
            String(selected).trim().toLowerCase() === String(option.label).trim().toLowerCase()
        );
    };
   
    useEffect(() => {
        getStates();
        //fetchTypeOfActivity();
        
    }, []);

    // Function to fetch sub-districts for auto-selected district
    const fetchSubDistricts = async(stateCode, districtCode) => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: stateCode.toString(),
                districtCode: districtCode.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/subdistrict`,
                requestOptions
            );

            const result = await response.text();
            const localFormDataSubDistrict = JSON.parse(result).dataContent;

            let myArraySubDistrict = [];
            localFormDataSubDistrict.map((item, key) => {
                myArraySubDistrict.push({ 
                    label: item.subDistrictName, 
                    value: item.subDistrictCode, 
                    districtCode: item.districtCode 
                });
            });

            setOptionSubDistrict(myArraySubDistrict);
            setIsFetching(false);
        } catch (error) {
            console.error("Error fetching sub-districts:", error);
        }
    };

    // Function to fetch villages for auto-selected sub-district
    const fetchVillages = async (stateCode, districtCode, subDistrictCode) => {
        // Check if we already tried to fetch villages for this combination
        const villageKey = `${stateCode}-${districtCode}-${subDistrictCode}`;
        if (fetchedVillageKeys.current.has(villageKey)) {
            return; // Don't fetch again
        }
        
        // Mark this combination as attempted
        fetchedVillageKeys.current.add(villageKey);
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: stateCode.toString(),
                districtCode: districtCode.toString(),
                subDistrictCode: subDistrictCode.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/village`,
                requestOptions
            );

            const result = await response.text();
            const parsedResult = JSON.parse(result);
            const localFormDataVillage = parsedResult.dataContent;

            let myArrayVillage = [];
            if (localFormDataVillage && localFormDataVillage.length > 0) {
                localFormDataVillage.map((item, key) => {
                    myArrayVillage.push({ 
                        label: item.villageName, 
                        value: item.villageCode, 
                        subDistrictCode: item.subDistrictCode 
                    });
                });
            }

            setOptionVillage(myArrayVillage);
            setIsFetching(false);
        } catch (error) {
            console.error("Error fetching villages:", error);
            setOptionVillage([]);
            setIsFetching(false);
        }
    };

    // New useEffect to handle user-level restrictions after states are loaded
    useEffect(() => {
        if (optionState.length > 0) {
            const userType = sessionStorage.getItem("userTypeCodeModel");
            // Try both possible session storage keys for state and district codes
             const stateCode = sessionStorage.getItem("stateNameModel");
             const districtCode = getStoredDistrictRef();
             const subDistrictCode = sessionStorage.getItem("subDistrictNameModel"); 
          
            // First, select the values based on user permissions
            if (userType === "2" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // State level user - auto-select state
                // Try to find the matching option and use its exact value format
                const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                if (matchingOption) {
                    setStateValue([matchingOption.value]);
                } else {
                    setStateValue([stateCode]);
                }
                setIsFetchingState(false); // Trigger district loading
            } else if (userType === "3" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // District level user - auto-select state
                const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                if (matchingOption) {
                    setStateValue([matchingOption.value]);
                } else {
                    setStateValue([stateCode]);
                }
                setIsFetchingState(false); // Trigger district loading
            } else if (userType === "4" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // Sub-district level user - auto-select state

                const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                if (matchingOption) {
                    setStateValue([matchingOption.value]);
                } else {
                    setStateValue([stateCode]);
                }
                setIsFetchingState(false); // Trigger district loading
            } else {
                // Regular user or admin - no auto-selection
                setStateValue([]);
            }
        }
    }, [optionState]); // Trigger when state options are loaded

    // Separate useEffect to freeze dropdowns after values are set
    useEffect(() => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const stateCode = sessionStorage.getItem("stateNameModel");
        const districtCode = getStoredDistrictRef();
        const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
        

        // Set disabled states based on user type and available values
        if (userType === "2" && stateCode && stateCode !== "null" && stateCode !== "0") {
            // State admin - freeze state dropdown only
            setIsStateDisabled(true);
            setIsDistrictDisabled(false);
            setIsSubDistrictDisabled(false);
        } else if (userType === "3" && stateCode && stateCode !== "null" && stateCode !== "0") {
            // District admin - freeze state and district dropdowns
            setIsStateDisabled(true);
            if (districtCode) {
                setIsDistrictDisabled(true);
            }
        } else if (userType === "4" && stateCode && stateCode !== "null" && stateCode !== "0") {
            // Sub-district admin - freeze state dropdown, others will be frozen after they're selected
            setIsStateDisabled(true);
            // For sub-district admin, also set district disabled state if district code is available
            if (districtCode && districtCode !== "null" && districtCode !== "0") {
                setIsDistrictDisabled(true);
            }
            // District and sub-district will be disabled in their respective useEffects
        } else {
            // Regular user - enable all
            setIsStateDisabled(false);
            setIsDistrictDisabled(false);
            setIsSubDistrictDisabled(false);
        }
    }, [stateValue]); // Trigger when stateValue changes

    // New useEffect to handle district auto-selection after districts are loaded
    useEffect(() => {
        if (optionDistrict.length > 0) {
            const userType = sessionStorage.getItem("userTypeCodeModel");
            const districtCode = getStoredDistrictRef();
            // First select the district value
            if ((userType === "3" || userType === "4") && districtCode && districtCode !== "null" && districtCode !== "0") {
                const matchingDistrictOption = findMatchingOption(optionDistrict, districtCode);
                if (matchingDistrictOption) {
                    setDistrictValue([matchingDistrictOption.value]);
                    setselectedDataSetDistrict(`${matchingDistrictOption.stateid}|${matchingDistrictOption.value}`);
                    
                    // Trigger sub-district loading by calling the API directly
                    const stateCode = stateValue[0] || sessionStorage.getItem("stateNameModel");
                    if (stateCode) {
                        fetchSubDistricts(stateCode, matchingDistrictOption.value);
                    }
                } else {
                    setDistrictValue([districtCode]);
                }
            }
        }
    }, [optionDistrict]); // Trigger when district options are loaded

    // Separate useEffect to freeze district dropdown after district value is set
    useEffect(() => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const districtCode = getStoredDistrictRef();
        
        // Freeze district dropdown for district and sub-district admins
        if ((userType === "3" || userType === "4") && districtCode && districtCode !== "null" && districtCode !== "0" && districtValue.length > 0) {
            setIsDistrictDisabled(true);
        }
    }, [districtValue]); // Trigger when districtValue changes

    // New useEffect to handle sub-district auto-selection after sub-districts are loaded
    useEffect(() => {
        if (optionSubDistrict.length > 0) {
            const userType = sessionStorage.getItem("userTypeCodeModel");
            const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
            
            // First select the sub-district value
            if (userType === "4" && subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0") {
                // Try to find matching option with different data types
                const matchingOption = optionSubDistrict.find(option => 
                    option.value == subDistrictCode || 
                    option.value === Number(subDistrictCode) || 
                    option.value === String(subDistrictCode)
                );
                
                if (matchingOption) {
                    setsubDistrictValue([matchingOption.value]);
                    setselectedDataSetSubDistrict(`${matchingOption.districtCode}|${matchingOption.value}`);
                    
                    // Trigger village loading for sub-district admin
                    const stateCode = stateValue[0] || sessionStorage.getItem("stateNameModel");
                    const districtCode = districtValue[0] || getStoredDistrictRef() || matchingOption.districtCode;
                    
                    console.log("Sub-district auto-selection - Village loading attempt:", {
                        stateCode,
                        districtCode,
                        subDistrictCode: matchingOption.value,
                        stateValue,
                        districtValue,
                        matchingOption
                    });
                    
                    if (stateCode && districtCode) {
                        // Add a small delay to ensure all state updates are processed
                        setTimeout(() => {
                            fetchVillages(stateCode, districtCode, matchingOption.value);
                        }, 100);
                    } else {
                        console.log("Village loading skipped - missing state or district code");
                    }
                } else {
                    setsubDistrictValue([subDistrictCode]);
                }
            }
        }
    }, [optionSubDistrict, stateValue, districtValue]); // Trigger when sub-district options are loaded and state/district values are set

    // Separate useEffect to freeze sub-district dropdown after sub-district value is set
    useEffect(() => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
        
        // Freeze sub-district dropdown for sub-district admins
        if (userType === "4" && subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0" && subdistrictValue.length > 0) {
            setIsSubDistrictDisabled(true);
        }
    }, [subdistrictValue]); // Trigger when subdistrictValue changes

    // Additional useEffect to ensure village loading for sub-district admin when all values are ready
    useEffect(() => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
        
                // If sub-district admin and all required values are available, ensure villages are loaded
        if (userType === "4" && 
            subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0" &&
            stateValue.length > 0 && 
            districtValue.length > 0 && 
            subdistrictValue.length > 0 &&
            optionVillage.length === 0) { // Only if villages aren't already loaded
            
            fetchVillages(stateValue[0], districtValue[0], subdistrictValue[0]);
        }
    }, [stateValue, districtValue, subdistrictValue, optionVillage]); // Trigger when any of these change

    useEffect(() => {
    const savedResults = sessionStorage.getItem("searchResults");
    const savedFilters = sessionStorage.getItem("searchFilters");

    if (savedResults && savedFilters) {
        setfarmerData(JSON.parse(savedResults));
        const filters = JSON.parse(savedFilters);
        setStateValue(filters.stateValue);
        setDistrictValue(filters.districtValue);
        setsubDistrictValue(filters.subDistrictValue);
        setvillageValue(filters.villageValue);
        setselectedDataSetDistrict(filters.selectedDataSetDistrict);
        setselectedDataSetSubDistrict(filters.selectedDataSetSubDistrict);
        setselectedDataSetVillage(filters.selectedDataSetVillage);
    }
}, []);



    useEffect(() => {

        if (isFetchingState == false) {

            handleState();
            setIsFetchingState(true);
        }

    }, [stateValue]);

    function getStates() {


        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            redirect: "follow",
        };
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/states`,
            requestOptions

        )
            .then((response) => response.text())
            // .then((result) => setVillageData(JSON.parse(result).dataContent) {
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent;
                console.log("localFormData", localFormDataState);
                let myArray = [];
                localFormDataState.map((item, key) => {
                    myArray.push({ label: item.stateName, value: item.stateCode })
                })
                console.log("myArray", myArray)
                setOptionState(myArray)
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
    }


    function handleState() {
        setOptionDistrict([]);
        setDistrictValue([]);
        setsubDistrictValue([]);
        setvillageValue([]);

        if (stateValue.length > 1) {
            alert('Please select one value');
            setStateValue([]);
            return false;
        }
        else {
            if (stateValue.length != 0) {

                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");

                let stateValueData = "";

                stateValue.map((item) => {
                    stateValueData = stateValueData + item + ","
                })

                stateValueData = stateValueData.slice(0, -1);
                var raw = JSON.stringify({
                    stateCode: stateValueData.toString()

                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/district`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataDistrict = JSON.parse(result).dataContent;

                        let myArrayDistrict = [];
                        localFormDataDistrict.map((item, key) => {
                            myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                        })

                        setOptionDistrict(myArrayDistrict)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));
            }
        }

    }

    let handleChangeDistrict = (districtValue) => {
        // Check if district selection is disabled for this user type
        if (isDistrictDisabled) {
            console.log("District change blocked - User has district restrictions");
            return;
        }
        
        setOptionSubDistrict([]);
        setsubDistrictValue([]);
        setvillageValue([]);
        if (districtValue.length > 1) {
            alert('Please select one value');
            setDistrictValue([]);
            return false;
        }
        else {
            setDistrictValue(districtValue.map(option => option.value));
            setselectedDataSetDistrict(districtValue.map(item => `${item.stateid}|${item.value}`).join(','));

            let stateValueData = "";

            stateValue.map((item) => {
                stateValueData = stateValueData + item + ","
            })

            if (districtValue.length != 0) {

                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                let districtValueData = "";
                districtValue.map((item) => {
                    districtValueData = districtValueData + item.value + ","
                })

                districtValueData = districtValueData.slice(0, -1);


                var raw = JSON.stringify({
                    stateCode: stateValueData.toString(),
                    districtCode: districtValueData.toString()

                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/subdistrict`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataSubDistrict = JSON.parse(result).dataContent;

                        let myArraySubDistrict = [];
                        localFormDataSubDistrict.map((item, key) => {
                            myArraySubDistrict.push({ label: item.subDistrictName, value: item.subDistrictCode, districtCode: item.districtCode })
                        })

                        setOptionSubDistrict(myArraySubDistrict)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));

            }
        }
    };

    let handleChangeSubDistrict = (subdistrictValue) => {
        // Check if sub-district selection is disabled for this user type
        if (isSubDistrictDisabled) {
            console.log("Sub-district change blocked - User has sub-district restrictions");
            return;
        }
        
        setvillageValue([]);
        setOptionVillage([]);
        if (subdistrictValue.length > 1) {
            alert('Please select one value');
            setsubDistrictValue([]);
            return false;
        }
        else {
            setsubDistrictValue(subdistrictValue.map(option => option.value));
            setselectedDataSetSubDistrict(subdistrictValue.map(item => `${item.districtCode}|${item.value}`).join(','));

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let stateValueData = "";

            stateValue.map((item) => {
                stateValueData = stateValueData + item
            })

            let districtValueData = "";
            districtValue.map((item) => {
                districtValueData = districtValueData + item
            })

            let subdistrictValueData = "";
            subdistrictValue.map((item) => {
                subdistrictValueData = subdistrictValueData + item.value
            })


            if (subdistrictValue.length != 0) {

                var raw = JSON.stringify({
                    stateCode: stateValueData.toString(),
                    districtCode: districtValueData.toString(),
                    subDistrictCode: subdistrictValueData.toString()

                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/village`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataVillage = JSON.parse(result).dataContent;

                        let myArrayVillage = [];
                        localFormDataVillage.map((item, key) => {
                            myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                        })

                        setOptionVillage(myArrayVillage)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));

            }
        }


    };

    const fetchDataFilterWise = async () => {

        setLoaderFarmer(true);
        setfarmerData([]);
        let stateValueData = "0";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";
         stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        stateValueData = stateValueData.slice(0, -1);

        if (selectedDataSetDistrict != "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
        }
        if (selectedDataSetSubDistrict != "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage != "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }
        let activityValueData = "";
        if (activityValue.length > 0) {
            activityValueData = activityValue[0];
        }
        let result;

        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": stateValueData,
                "districtCode": districtValueData,
                "subDistrictCode": subdistrictValueData,
                "villageCode": villageValueData,
                "ActivityType": activityValueData,
                "PageNumber": page
            })


            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
            sessionStorage.setItem("searchResults", JSON.stringify(data));
            sessionStorage.setItem("searchFilters", JSON.stringify({
                stateValue,
                districtValue,
               
                villageValue,
                selectedDataSetDistrict,
                selectedDataSetSubDistrict,
                selectedDataSetVillage
            }));
            if (result.data.success != true) {
                  alert('No Data Found.');
                  setLoaderFarmer(false);
            }


        }
    }

    let handleChange = (stateValue) => {
        // Check if state selection is disabled for this user type
        if (isStateDisabled) {
            console.log("State change blocked - User has state restrictions");
            return;
        }
        
        console.log("selected State", stateValue);
        setIsFetchingState(false);
        setStateValue(stateValue.map(option => option.value));

    };

    let handleChangeVillage = (villageValue) => {
        if (villageValue.length > 1) {
            alert('Please select one value');
            setvillageValue([]);
            return false;
        }
        else {

            setvillageValue(villageValue.map(option => option.value));
            setselectedDataSetVillage(villageValue.map(item => `${item.subDistrictCode}|${item.value}`).join(','));
        }
    };

    const fetchTypeOfActivity = async (stateCode, districtCode) => {
        try {
            const apiBase = process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE;
            const raw = JSON.stringify({
                // flag: "Surveyor",
                // userTypeCode: Number(sessionStorage.getItem("userTypeCodeModel")) || 2,
                // stateCode: Number(stateCode),
                // districtCode: String(districtCode),
                // type: 1
            });

            const resultText = await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open("GET", `${apiBase}/api/Nature/farmertype/GetTypeofActivity`, true);
                xhr.setRequestHeader("accept", "*/*");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            resolve(xhr.responseText);
                        } else {
                            reject(new Error(xhr.statusText || "Failed to fetch activities"));
                        }
                    }
                };
                xhr.onerror = () => reject(new Error("Failed to fetch activities"));
                xhr.send(raw);
            });

            const parsedResult = JSON.parse(resultText);
            const localFormDataActivity = parsedResult.dataContent || [];
            let myArrayActivity = [];
            localFormDataActivity.map((item) => {
                myArrayActivity.push({
                    label: item.activity_description,
                    value: item.code_type
                });
            });
            setOptionActivity(myArrayActivity);
        } catch (error) {
            console.error("Error fetching activities:", error);
            setOptionActivity([]);
        }
    };

    let handleChangeActivity = (selectedActivity) => {
        if (selectedActivity.length > 1) {
            alert('Please select one value');
            setactivityValue([]);
            return false;
        }
        if (selectedActivity.length === 0) {
            setactivityValue([]);
            return;
        }
        setactivityValue(selectedActivity.map((option) => option.value));
    };

    useEffect(() => {
        //if (stateValue.length > 0 && districtValue.length > 0) {
            setactivityValue([]);
            fetchTypeOfActivity(stateValue[0], districtValue[0]);
        //} else {
            setOptionActivity([]);
            setactivityValue([]);
        //}
    }, [stateValue, districtValue]);

    function formatData(value) {
        if (sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "10" || sessionStorage.getItem("schemeCodeModel") === "11") {
            return value.componentName
        }
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Honey Processing Unit"
        } else if (value.orgTypeCode === 2) {
            return "Honey Testing Unit"
        } else if (value.orgTypeCode === 3) {
            return "Honey CHC"
        } else if (value.orgTypeCode === 4) {
            return "Beeflora Plantation"
        }
    }

    function formatData2(value) {
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Nursery"
        } else if (value.orgTypeCode === 2) {
            return "Tissue Culture Unit"
        } else {
            return "Tissue Culture Unit"
        }
    }

    const fetchDataExporttoCsv = async () => {
      setLoaderFarmer(true);
      
      let stateValueData = "";
      let districtValueData = "0";
      let subdistrictValueData = "0";
      let villageValueData = "0";

      // Concatenate all state values with a comma
      stateValue.forEach((item) => {
        stateValueData += item + ",";
      });
      // Remove trailing comma
      stateValueData = stateValueData.slice(0, -1);

      // If stateValueData is null or empty, set stateCode to "0"
      const stateCode = stateValueData === "" || stateValueData === null ? "0" : stateValueData;

      if (selectedDataSetDistrict !== "") {
        const districtParts = selectedDataSetDistrict.split("|");
        districtValueData = districtParts[1];
      }
      if (selectedDataSetSubDistrict !== "") {
        const SubdistrictParts = selectedDataSetSubDistrict.split("|");
        subdistrictValueData = SubdistrictParts[1];
      }
      if (selectedDataSetVillage !== "") {
        const VillageDataParts = selectedDataSetVillage.split("|");
        villageValueData = VillageDataParts[1];
      }
      

      let result;
      if (sessionStorage.getItem("schemeCodeModel") === "12") {
        result = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsExport`,
          {
            
            stateCode: stateCode, // Use our conditional stateCode here
            districtCode: districtValueData,
            subDistrictCode: subdistrictValueData,
            villageCode: villageValueData,
            PageNumber: 1,
          }
        );
        if (result.data.success === true) {
          const data = await result.data.dataContent;
          setIsFetching(false);
          setLoaderFarmer(false);
          return data;
        } else {
          alert("something went wrong.");
          setLoaderFarmer(false);
        }
      }
    };


    const handleExportDataNew = async () => {
        
        let allowed;
        const farmerDataExportNew = await fetchDataExporttoCsv();
        allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        //console.log("Test Data", farmerDataExportNew[0]);
        var result = farmerDataExportNew.map(function (obj) {
            var newObj = {};

            allowed.forEach(function (key) {

                newObj[key] = obj[key];


            });
            return newObj;
        });
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);

    }
  

    const handleExportData = () => {
        const flattenObject = (obj, parentKey = '', result = {}) => {
            for (let key in obj) {
                if (!obj.hasOwnProperty(key)) continue;
                const fullKey = parentKey ? `${parentKey}.${key}` : key;

                if (Array.isArray(obj[key]) && obj[key].length > 0 && typeof obj[key][0] === 'object') {
                    flattenObject(obj[key][0], '', result);
                } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                    flattenObject(obj[key], fullKey, result);
                } else {
                    result[key] = obj[key];
                }
            }
            return result;
        };

        let exportData = farmerData?.map(item => flattenObject(item));

        const allKeys = new Set();
        exportData.forEach(row => {
            Object.keys(row).forEach(key => allKeys.add(key));
        });

        const headers = Array.from(allKeys);
        const headerLabelMap = {
            landArea: "Land Area (acres)",
        };
        const exportHeaders = headers.map((key) => headerLabelMap[key] || key);

        const result = exportData.map(item => {
            const row = {};
            headers.forEach((key, index) => {
                row[exportHeaders[index]] = item[key] ?? '';
            });
            return row;
        });

        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: exportHeaders,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);
    };

    const handlePrevPage = async () => {
        setLoaderFarmer(true);
        let result;
        setPage(page - 1);
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1
            })
        }
       else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page - 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        setIsFetching(false);
        setHasNextPage(true)
    };

    const handleNextPage = async () => {
        setLoaderFarmer(true);

        setPage(page + 1);
        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page + 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        if (result.data.message === "Data Not Found") {
            setHasNextPage(false)
        }
        setIsFetching(false);
    };

    function ClearSearch(){
        // Only clear fields that are not disabled for this user type
        if (!isStateDisabled) {
            setStateValue([]);
            setOptionDistrict([]);
        }
        if (!isDistrictDisabled) {
            setDistrictValue([]);
            setselectedDataSetDistrict('');
            setOptionSubDistrict([]);
        }
        if (!isSubDistrictDisabled) {
            setsubDistrictValue([]);
            setselectedDataSetSubDistrict('');
        }
        
        // Always clear these fields regardless of user type
        setfarmerData([]);
        setOptionVillage([]);
        setvillageValue([]);
        setselectedDataSetVillage('');
        setOptionActivity([]);
        setactivityValue([]);
        setSurveyValue('');
        setSurveyorNameValue('');
        setStartDate("");
        setEndDate("");
        sessionStorage.removeItem("searchResults");
        sessionStorage.removeItem("searchFilters");

    }

    function ValidateAddUser() {
    if (stateValue.length === 0) {
       
         setErrorMessage("Please select at least one State.");
            return false;
    }
    if (stateValue.length > 1) {
       setErrorMessage("Please select only one State.");
            return false;
    }
    
    if (districtValue.length > 1) {
        setErrorMessage('Please select only one District');
        return false;
    }
    
    if (sessionStorage.getItem("schemeCodeModel") === "12") {
    if (!startDate) {
         setErrorMessage('Start Date is required.');
       
        return false;
    }

     if (!endDate) {
        setErrorMessage('End Date is required.');
        return false;
    } else if (startDate && endDate < startDate) {
        setErrorMessage('End Date cannot be earlier than Start Date.');
        return false;
        
    }

    }
    // If all validations pass, fetch the filtered data
    setErrorMessage("") 
    fetchDataFilterWise();

    }
    function navigateData(userData) {
        navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: userData } })
    }
    const columns = useMemo(() => {
        const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");

        return [
            {
              header: 'S.No',
              Cell: cell => Number(cell.row.id) + 1,
              size: 40, // set width
              muiTableBodyCellProps: { sx: { px: 1, py: 0.5 } }, // reduce padding
            },
             // View Details Button Logic
            (schemeCodeModel === "12" || schemeCodeModel === "13") ? {
                accessor: '',
                header: 'View Details',
                Cell: cell => (
                    <button className="btn" type="button" onClick={() => navigate("/newadminpanel/survey/detailview", { state: { farmerCode: cell.row.original } })}>
                        <i><FontAwesomeIcon icon={faEye} /></i>
                    </button>
                )
            } : (schemeCodeModel === "9") ? {
                accessor: '',
                header: 'Action',
                Cell: cell => (<>
                    <i className="btn" type="button" onClick={() => navigateData(cell.row.original)}> <FontAwesomeIcon icon={faEye} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop_user" onClick={() => setEditCode(cell.row.original.farmerCode)}> <FontAwesomeIcon icon={faEdit} /></i>
                </>)
            } : {
                accessor: '',
                header: 'View Details',
                size: 100,

                Cell: cell => (
                    <button className="btn" type="button" onClick={() => navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: cell.row.original } })}>
                        <i><FontAwesomeIcon icon={faEye} /></i>
                    </button>
                )

            },
            {
                accessorKey: 'farmerName',
                header: 'Farmer Name',
                size: 120,
            },
            {
                accessorKey: 'landArea',
                header: 'Land Area (acres)',
                size: 120,
            },
            {
                accessorKey: 'surveyorName',
                header: 'Surveyor Name',
                size: 140,
            },
            {
                accessorKey: 'stateName',
                header: 'State',
                size: 120,
            },
            {
                accessorKey: 'districtName',
                header: 'District',
                size: 120,
            },{
                accessorKey: 'subDistrictName',
                header: 'SubDistrict',
                size: 120,
            },{
                accessorKey: 'villageName',
                header: 'Village',
                size: 120,
            },
           {
                accessorKey: 'activityType',
                header: 'Activity Type',
                size: 120,
            },
            
                 ...(schemeCodeModel === "15" ? [
        { accessorKey: 'userName', header: 'User Name' },
        { accessorKey: 'sectorName', header: 'Sector Name' },
        { accessorKey: 'projectStatus', header: 'Project Status' }
    ] : []),

           
       
        ].filter(Boolean); // Use .filter(Boolean) to remove null entries
    }, []);


    return (
        <>
          
           <section className="section">

                <div className="row surveydetailsBg">
                    <div className="col-md-3">
                        <label htmlFor="State" className="form-label">
                            State
                        </label><label style={{ color: "red" }}>*</label>
                        <Select
                            options={optionState}
                            value={optionState.filter(option => isOptionSelected(stateValue, option))[0] || null}
                            onChange={isStateDisabled ? () => {} : (opt) => handleChange(opt ? [opt] : [])}
                            isClearable={!isStateDisabled}
                            isSearchable
                            isDisabled={isStateDisabled}
                            placeholder="Select State"
                            classNamePrefix="select"
                        />
                    </div>

                    <div className="col-md-3">
                        <label htmlFor="District" className="form-label">
                            District
                        </label>
                        <Select
                            options={optionDistrict}
                            value={optionDistrict.filter(option => isOptionSelected(districtValue, option))[0] || null}
                            onChange={isDistrictDisabled ? () => {} : (opt) => handleChangeDistrict(opt ? [opt] : [])}
                            isClearable={!isDistrictDisabled}
                            isSearchable
                            isDisabled={isDistrictDisabled}
                            placeholder="Select District"
                            classNamePrefix="select"
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="SubDistrict" className="form-label">
                            Sub District
                        </label><label style={{ color: "red" }}></label>
                        <Select
                            options={optionSubDistrict}
                            value={optionSubDistrict.filter(option => isOptionSelected(subdistrictValue, option))[0] || null}
                            onChange={isSubDistrictDisabled ? () => {} : (opt) => handleChangeSubDistrict(opt ? [opt] : [])}
                            isClearable={!isSubDistrictDisabled}
                            isSearchable
                            isDisabled={isSubDistrictDisabled}
                            placeholder="Select Sub District"
                            classNamePrefix="select"
                        />
                    </div>

                    <div className="col-md-3">
                        <label htmlFor="Village" className="form-label">
                            Village
                        </label><label style={{ color: "red" }}></label>
                        <Select
                            options={optionVillage}
                            value={optionVillage.filter(option => isOptionSelected(villageValue, option))[0] || null}
                            onChange={(opt) => handleChangeVillage(opt ? [opt] : [])}
                            isClearable
                            isSearchable
                            placeholder="Select Village"
                            classNamePrefix="select"
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="Activity" className="form-label">
                            Activity
                        </label><label style={{ color: "red" }}></label>
                        <Select
                            options={optionActivity}
                            value={optionActivity.filter(option => isOptionSelected(activityValue, option))[0] || null}
                            onChange={(opt) => handleChangeActivity(opt ? [opt] : [])}
                            isClearable
                            isSearchable
                            placeholder="Select Activity"
                            classNamePrefix="select"
                        />
                    </div>
                    
                  <br /> <br />                     
                  <div className="col-md-12 d-flex justify-content-md-center mt-3">

                    <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={ValidateAddUser} >Submit</button>
                    <button type="button" className="btn btn-success me-md-2"  onClick={ClearSearch}>Clear</button>
                </div>

                </div>
                
                {errorMessage && (
                        <div className="alert alert-danger" role="alert">
                         {errorMessage}
                        </div>
                    )} 

       
            {LoaderFarmer === false ? "" : <div className="overlay">
                <div className="overlay__inner">
                    <div className="overlay__content"><span className="spinner"></span></div>
                </div>
            </div>}


                    {(farmerData.length!=0  &&
                    <div className="row justify-content-lg-center">

                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={farmerData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                    state={{ isLoading: isFetching ? true : false }}
                                    renderTopToolbarCustomActions={({ table }) => (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: "1rem",
                                                p: "0.5rem",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            {sessionStorage.getItem("schemeCodeModel") === "12" ?
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportDataNew}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>

                                                :
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportData}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>
                                            }

                                        </Box>
                                    )}
                                />
                                

                            </div>

                        </div>


                    </div>
                )}
           </section>
        </>
    )
}

export default PDMCList;
